function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFiles from '../use-files';
import { FILE_STATUS } from '../constants';
import { getFileUploadOptions } from '../selectors';
import FileUploader from './FileUploader';
import FileList from './FileList';
import FileValidation from './FileValidation';
var fileIsSuccessOrInProgress = function fileIsSuccessOrInProgress(file) {
  return [FILE_STATUS.STATUS_UPLOAD_SUCCESS, FILE_STATUS.STATUS_UPLOAD_PROCESSING].indexOf(file.status) !== -1;
};
var noop = function noop() {};
var Files = function Files(_ref) {
  var _ref$additionalInform = _ref.additionalInformation,
    AdditionalInformation = _ref$additionalInform === void 0 ? function () {
      return null;
    } : _ref$additionalInform,
    _ref$allowAnonymousUp = _ref.allowAnonymousUploads,
    allowAnonymousUploads = _ref$allowAnonymousUp === void 0 ? false : _ref$allowAnonymousUp,
    _ref$apiRoot = _ref.apiRoot,
    apiRoot = _ref$apiRoot === void 0 ? '/api/file' : _ref$apiRoot,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$dragAndDropEnabl = _ref.dragAndDropEnabled,
    dragAndDropEnabled = _ref$dragAndDropEnabl === void 0 ? true : _ref$dragAndDropEnabl,
    enablePreviews = _ref.enablePreviews,
    fileRenderer = _ref.fileRenderer,
    fileUploadButton = _ref.fileUploadButton,
    _ref$maxUploads = _ref.maxUploads,
    maxUploads = _ref$maxUploads === void 0 ? 25 : _ref$maxUploads,
    methods = _ref.methods,
    name = _ref.name,
    _ref$onFileRemoved = _ref.onFileRemoved,
    onFileRemoved = _ref$onFileRemoved === void 0 ? noop : _ref$onFileRemoved,
    required = _ref.required,
    type = _ref.type;
  var _useState = useState(maxUploads),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfUploadsRemaining = _useState2[0],
    setNumberOfUploadsRemaining = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    maxUploadsExceeded = _useState4[0],
    setMaxUploadsExceeded = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    progress = _useState6[0],
    setProgress = _useState6[1];
  var _useFiles = useFiles({
      control: methods.control,
      enablePreviews: enablePreviews,
      name: name,
      type: type
    }),
    addAcceptedFiles = _useFiles.addAcceptedFiles,
    addRejectedFiles = _useFiles.addRejectedFiles,
    _updateFiles = _useFiles.updateFiles,
    files = _useFiles.files,
    _removeFile = _useFiles.removeFile;
  var application = useSelector(function (state) {
    return state.application;
  });
  var fileUploadOptions = getFileUploadOptions({
    allowAnonymousUploads: allowAnonymousUploads,
    application: application,
    maxUploads: maxUploads,
    type: type
  });
  var handleFileRemoved = function handleFileRemoved() {
    setMaxUploadsExceeded(false);
    onFileRemoved.apply(void 0, arguments);
  };

  // Update our number of uploads remaining
  useEffect(function () {
    var currentFiles = methods.getValues(name);
    var numberOfFiles = currentFiles && currentFiles.length ? currentFiles.filter(fileIsSuccessOrInProgress).length : 0;
    var newRemainingUploadCount = maxUploads - numberOfFiles;
    if (newRemainingUploadCount !== numberOfUploadsRemaining) {
      setNumberOfUploadsRemaining(newRemainingUploadCount);
    }
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FileUploader, {
    addAcceptedFiles: addAcceptedFiles,
    addRejectedFiles: addRejectedFiles,
    apiRoot: apiRoot,
    disabled: disabled,
    dragAndDropEnabled: dragAndDropEnabled,
    fileUploadButton: fileUploadButton,
    fileUploadOptions: fileUploadOptions,
    files: files,
    maxUploads: maxUploads,
    maxUploadsExceeded: maxUploadsExceeded,
    numberOfUploadsRemaining: numberOfUploadsRemaining,
    setMaxUploadsExceeded: setMaxUploadsExceeded,
    setProgress: setProgress,
    testAttribute: name,
    updateFiles: function updateFiles() {
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }
      return _updateFiles.apply(void 0, [methods.getValues(name)].concat(rest));
    }
  }), /*#__PURE__*/React.createElement(AdditionalInformation, null), /*#__PURE__*/React.createElement(FileValidation, {
    name: name,
    required: required
  }), /*#__PURE__*/React.createElement(FileList, {
    disabled: disabled,
    fileRenderer: fileRenderer,
    files: files,
    onFileRemoved: handleFileRemoved,
    progress: progress,
    removeFile: function removeFile() {
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }
      return _removeFile.apply(void 0, [methods.getValues(name)].concat(rest));
    },
    required: required
  }));
};
export default Files;